import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

// components
import { SharedComponents } from './components';

// pipes
import { SharedPipes } from './pipes';

// pipes
import { SharedModals } from './components/modals';

// services
import { SharedServices } from './services';

// External
import { TranslateModule } from '@ngx-translate/core';
import { FormModules } from './shared-bootstraps';

// Material
import { MaterialUIComponents } from '@base-shared/material.declarations';

import { GalleryModule } from '@ngx-gallery/core';
import { LightboxModule } from '@ngx-gallery/lightbox';
import { SharedModule } from '@base/shared/shared.module';

@NgModule({
  declarations: [
    SharedComponents(),
    SharedPipes(),
    SharedModals()
  ],
  imports: [
    CommonModule,
    TranslateModule,
    GalleryModule,
    LightboxModule,
    FormModules(),
    MaterialUIComponents(),
    SharedModule
  ],
  exports: [
    SharedComponents(),
    SharedPipes(),
    SharedModals(),
    MaterialUIComponents(),
    GalleryModule,
    LightboxModule
  ],
  providers: [
    SharedServices()
  ],
  entryComponents: [
    SharedModals(),
  ],
  //schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class EyrusSharedModule { }
